import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { ShowIfPermittedDirective } from 'src/app/module/order-list/directives/show-if-permitted.directive';
import { AppPermission } from 'src/app/shared/interface/common.interface';
import { UserState } from 'src/app/shared/state/user.state';

@Component({
  selector: 'app-order-submitted-page',
  standalone: true,
  imports: [MatButtonModule, MatIconModule, ShowIfPermittedDirective],
  templateUrl: './order-submitted-page.component.html',
  styleUrl: './order-submitted-page.component.scss',
})
export class OrderSubmittedPageComponent {
  permission = AppPermission;

  private _orderId = this._route.snapshot.paramMap.get('orderId');

  constructor(
    public router: Router,
    public userState: UserState,
    private _route: ActivatedRoute
  ) {}

  navigateToPreview() {
    this.router.navigate(['/orders', this._orderId, 'view']);
  }
}
